import { createFileRoute } from "@tanstack/react-router";
import { ArticlePage } from "@/components/ArticlePage";
import { articleSchemas, qaSchema } from "@/lib/seo";

const UPDATED = "2026-10-14";
const ANSWER = "Shopify passt, wenn Sie schnell und planbar verkaufen wollen und keine eigene Technik pflegen möchten. Shopware passt eher, wenn Sie sehr individuelle Abläufe haben und ein Entwicklerteam für Hosting und Updates bezahlen wollen. Für die meisten kleinen und mittleren Händler ist Shopify die einfachere und günstigere Lösung im Betrieb.";
const SITE = "https://shopify-freelancer.net";
const PATH = "/fragen/shopify-vs-shopware";
const TITLE = "Shopify oder Shopware: was passt besser?";
const DESCRIPTION = "Shopify vs Shopware im Vergleich: Kosten, Pflegeaufwand, Flexibilität und für welche Händler sich welches System lohnt.";

const faqs = [
  { q: "Was ist günstiger?", a: "Im Betrieb ist Shopify für kleine und mittlere Shops meist günstiger, weil Hosting und Wartung entfallen." },
  { q: "Kann ich von Shopware zu Shopify wechseln?", a: "Ja. Produkte, Kunden und Bestellungen lassen sich übernehmen, Weiterleitungen sichern Ihre Google-Rankings." },
  { q: "Welches System ist besser für SEO?", a: "Beide sind gut. Entscheidend sind Inhalte, Ladezeit und saubere Struktur, nicht das System." },
];

export const Route = createFileRoute("/fragen/shopify-vs-shopware")({
  component: Page,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: `${SITE}${PATH}` },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${SITE}${PATH}` }],
    scripts: [
      ...articleSchemas({ title: TITLE, description: DESCRIPTION, path: PATH, faqs, section: "Shopify vs Shopware", updated: UPDATED, breadcrumb: { name: "Fragen", path: "/fragen" } }),
      qaSchema({ question: TITLE, answer: ANSWER, path: PATH, updated: UPDATED }),
    ],
  }),
});

function Page() {
  return (
    <ArticlePage
      kicker="Frage · Vergleich"
      title={TITLE}
      intro="Beide Systeme sind ausgereift. Der Unterschied liegt vor allem darin, wer sich um Technik, Updates und Hosting kümmert."
      source="frage-shopify-vs-shopware"
      answer={ANSWER}
      updated={UPDATED}
      breadcrumb={{ to: "/fragen", label: "Fragen" }}
      sections={[
        { h: "Der Kernunterschied", p: [], list: ["Shopify: gemietete Plattform, Shopify kümmert sich um Server und Sicherheit", "Shopware: eigene Installation, Sie oder eine Agentur pflegen Hosting und Updates", "Shopify: laufende Gebühren, dafür wenig Wartung", "Shopware: mehr Freiheit, dafür höherer Pflegeaufwand"] },
        { h: "Wann Shopify die bessere Wahl ist", p: ["Wenn Sie ohne eigenes Technikteam arbeiten, schnell starten wollen und Ihre Abläufe zu einem Standardshop passen."] },
        { h: "Wann Shopware die bessere Wahl ist", p: ["Wenn Sie sehr spezielle Preis- oder Produktlogik haben und ohnehin mit einer Agentur zusammenarbeiten."] },
      ]}
      faqs={faqs}
      related={[{ to: "/fragen/shopify-oder-woocommerce", label: "Shopify oder WooCommerce?" }, { to: "/fragen/shopify-erfahrungen", label: "Shopify Erfahrungen" }, { to: "/shopify-shop-erstellen-lassen", label: "Shop erstellen lassen" }]}
    />
  );
}
